import { render, staticRenderFns } from "./ErrorLabel.vue?vue&type=template&id=c503faf2&scoped=true"
import script from "./ErrorLabel.vue?vue&type=script&lang=js"
export * from "./ErrorLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c503faf2",
  null
  
)

export default component.exports